import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
  ConfirmDeleteDialog,
  DeleteMessageType,
} from '~teacher/components/QuizEditor/ConfirmDeleteDialog';
import QuizStandards from '~teacher/components/QuizStandards/QuizStandards';
import { handleUnexpectedError } from '~teacher/slices/quiz/quizAppThunks';
import { selectEditingQuiz } from '~teacher/slices/quiz/quizSelectors';
import {
  changeStatusToOk,
  changeStatusToSaving,
  updateQuizStandard,
} from '~teacher/slices/quiz/quizSlice';

import { deleteStandard } from '../../../../../api/standardApi';

export function AlignToStandards({
  isControlsDisabled,
  editQuizController,
  isAlignToStandardSectionOpen,
  handleAlignQuizToStandardToggle,
  setShowDeleteStandardModal,
  showStandardDeleteModal,
}: {
  editQuizController: any;
  isControlsDisabled: boolean;
  isAlignToStandardSectionOpen: boolean;
  handleAlignQuizToStandardToggle: (checked: boolean) => void;
  setShowDeleteStandardModal: React.Dispatch<React.SetStateAction<boolean>>;
  showStandardDeleteModal: boolean;
}) {
  const dispatch = useDispatch();

  const quiz = useSelector(selectEditingQuiz);

  const { standard, id: quizId } = quiz;
  const standardId = standard?.id;

  const handleDeleteStandard = async () => {
    if (standardId) {
      dispatch(changeStatusToSaving());
      try {
        await deleteStandard({
          quizId: quizId,
          standardId: standardId,
        });
        dispatch(updateQuizStandard(null));
        dispatch(changeStatusToOk());
        setShowDeleteStandardModal(false);
        editQuizController.deleteStandard();
      } catch (e: unknown) {
        dispatch(handleUnexpectedError(e));
      }
    }
  };

  const handleCancelEditStandard = () => {
    if (standardId) {
      editQuizController.cancelEditStandardClicked();
    } else {
      handleAlignQuizToStandardToggle(false);
    }
  };

  return (
    <>
      {isAlignToStandardSectionOpen && (
        <QuizStandards
          controller={editQuizController}
          quizId={quizId}
          standardId={standardId}
          onCancelEditStandardClicked={handleCancelEditStandard}
          onDeleteStandardClicked={() => setShowDeleteStandardModal(true)}
        />
      )}
      <ConfirmDeleteDialog
        open={showStandardDeleteModal}
        onClose={() => setShowDeleteStandardModal(false)}
        deleteMessageType={DeleteMessageType.DeleteStandard}
        onDelete={handleDeleteStandard}
        isModalDisabled={isControlsDisabled}
      />
    </>
  );
}
